import { formatWeekYearAsDate } from '@bestseller/retail-planning.styletimeline';
import { addWeeks } from 'date-fns';
import { formatDateAsWeekYear } from './formatAsWeekYear';

export function calculateSuggestedNormClosureWeek(exitWeek: number | null): number | null {
    if (typeof exitWeek !== 'number') {
        return null;
    }
    // logic: Norm closure week is 4 weeks before exit week
    const normClosureDate = addWeeks(formatWeekYearAsDate(exitWeek), -4);
    return formatDateAsWeekYear(normClosureDate);
}
